import { Link, NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export function AdminLayout() {
  const { user, logout } = useAuth();
  return (
    <div className="admin-shell">
      <header className="admin-header">
        <Link to="/admin" className="brand">
          Exam Platform
        </Link>
        <nav>
          <NavLink to="/admin/users">Users</NavLink>
          <NavLink to="/admin/tests">Tests</NavLink>
        </nav>
        <div className="user-area">
          {user && (
            <span>
              {user.username} <small>({user.role})</small>
            </span>
          )}
          <button onClick={() => void logout()}>Log out</button>
        </div>
      </header>
      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
}
